import { render } from "./SharedAnnotations.vue?vue&type=template&id=34bc7e0e&scoped=true"
import script from "./SharedAnnotations.vue?vue&type=script&lang=js"
export * from "./SharedAnnotations.vue?vue&type=script&lang=js"

import "./SharedAnnotations.vue?vue&type=style&index=0&id=34bc7e0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34bc7e0e"]])

export default __exports__